import type { ChartsTrack } from '~/types/ChartsTrack'
import type { CoreFetch } from '~/types/CoreFetch'
import type { PaginatedApiResponseSansCount } from '~/types/PaginatedApiResponse'

export function provideFetchChartTracks(coreFetch: CoreFetch) {
  /**
   * Fetches the paginated list of chart tracks.
   *
   * @param cursor - Encoded strings used for "next"|"previous" urls provided by the backend (e.g. "cD0yMA%3D%3D")
   * @param country - The country to filter to.
   * @param genre - The genre to filter to.
   * @returns A promise that resolves to the paginated list of chart tracks.
   */
  return function (
    cursor?: Record<string, string>,
    country?: string,
    genre?: string,
  ) {
    const countryParam = country && country !== 'all' ? country : 'all'
    const genreParam = genre ? genre : 'all'

    /**
     * Url structure: either '/track/chart/' or '/track/chart/{country}/{genre}/'
     * Viable urls include: '/track/chart/' (same as '/track/chart/all/all'), '/track/chart/all/rock-punk/', '/track/chart/us/rock-punk/', '/track/chart/us/all/'
     * Non-viable urls: '/track/chart/all/' (expects both country & genre), '/track/chart/us/' (same), '/track/chart/rock-punk/' (using a genre as the country name)
     */
    return coreFetch.$get<PaginatedApiResponseSansCount<ChartsTrack>>(
      `/track/chart/${countryParam}/${genreParam}`.replaceAll(/\/+/gi, '/'),
      {
        params: cursor,
      },
    )
  }
}
